import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

interface VehicleNumberEditDialogProps {
  open: boolean;
  currentVehicleNo: string;
  newVehicleNo: string;
  isUpdating: boolean;
  onNewVehicleNoChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

const VehicleNumberEditDialog: React.FC<VehicleNumberEditDialogProps> = ({
  open,
  currentVehicleNo,
  newVehicleNo,
  isUpdating,
  onNewVehicleNoChange,
  onSave,
  onCancel,
}) => {
  const isValid = newVehicleNo.trim().length > 0 && newVehicleNo !== currentVehicleNo;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Vehicle Number</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Current Vehicle Number"
            value={currentVehicleNo}
            fullWidth
            disabled
            variant="outlined"
          />
          <TextField
            label="New Vehicle Number"
            value={newVehicleNo}
            onChange={(e) => onNewVehicleNoChange(e.target.value)}
            fullWidth
            placeholder="Enter new vehicle number"
            autoFocus
            disabled={isUpdating}
            variant="outlined"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} sx={{ color: "red" }} disabled={isUpdating}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          sx={{ backgroundColor: "#00CD5B" }}
          disabled={!isValid || isUpdating}
          startIcon={isUpdating ? <CircularProgress size={20} /> : null}
        >
          {isUpdating ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VehicleNumberEditDialog;
